import * as React from 'react';
import { DataGrid } from '@material-ui/data-grid';
import { rows as old } from './stockDataMateria';

const Restock = (props) => {




	var rows = [];

	for (var i = 0; i < old.length; i++) {
		if (old[i].Quantity/old[i].Times_bought <.05 && old[i].Item_revenue > 16) {
			rows.push(old[i]);
		}
	}



	const columns = [
	{ field: 'id', headerName: 'ID', width: 120 },
	{ field: 'Item', headerName: 'Item Name', width: 150 },

	{
		field: 'Price',
		headerName: 'Price($)',
		type: 'number',
		width: 160,
	},

	{
		field: 'Quantity',
		headerName: 'Quantity',
		type: 'number',
		width: 160,
	},

	{
		field: 'Times_bought',
		headerName: 'Times bought',
		type: 'number',
		width: 180,
	},

	{
		field: 'Item_revenue',
		headerName: 'Item Revenue($)',
		type: 'number',
		width: 190,
	}

	];





	return (
    <div style={{ height: 700, width: '96%' }} className="container">
      <DataGrid rows={rows} columns={columns} pageSize={10} />
    </div>
			)
}

export default Restock;